import React from 'react';
import {connect} from 'react-redux';
import NumberFormat from 'react-number-format';

import {numberFormat} from '../../Utilities';

const Number = props => {
    let format = props.format ? {...props.format} : {...numberFormat().currencyWithMinus};
    let props2 = {...props};
    delete props2.format;
    delete props2.dispatch;
    let text = props.istext === 0 ? null : {displayType: 'text'};

    return <NumberFormat
        {...props2}
        {...format}
        {...text}
    />;
};

function mapStateToProps(state) {
    const {language} = state.languageReducer;
    return {
        language
    };
}

const connectedNumber = connect(mapStateToProps)(Number);
export {connectedNumber as Number};